// extracted by mini-css-extract-plugin
module.exports = {"column":"sIT8t","highlight":"IUXCL","inner":"Grr2c","edge":"_6Mrca"};